import { createFileRoute } from "@tanstack/react-router";
import { getCity } from "@/lib/seo/cities";
import { filmproduktionForCity } from "@/lib/seo/localAreaCopy";
import { cityHubRoute } from "@/lib/seo/cityHubRoute";

const city = getCity("skelleftea")!;
const page = filmproduktionForCity(city);

export const Route = createFileRoute("/filmproduktion_/skelleftea")(cityHubRoute(city, page));
